import React from "react";

const MailIcon = props => (
  <svg width={102} height={88} viewBox="-7 0 88 88" fill="none" {...props}>
    <path
      d="M17.97 10.13H60.03a17.8 17.8 0 0117.84 17.839v42.062a17.8 17.8 0 01-17.84 17.84H17.969A17.8 17.8 0 01.13 70.03V27.969a17.8 17.8 0 0117.84-17.84z"
      fill="url(#prefix__paint0_linear)"
    />
    <path
      d="M17.163 32.237c-.41 0-.796.07-1.161.216l7.315 7.531 7.396 7.666.135.162.216.216.216.216.432.459 6.343 6.505c.106.066.412.35.651.47.308.153.642.295.986.307.371.014.751-.093 1.085-.255.25-.122.362-.297.652-.522l7.343-7.585 7.423-7.639 7.153-7.369a3.138 3.138 0 00-1.511-.378H17.162zm-2.241.918c-.78.739-1.269 1.85-1.269 3.104v24.726c0 1.015.326 1.938.864 2.645l1.026-.971 7.639-7.424 6.775-6.559-.135-.162-7.423-7.64-7.423-7.665-.054-.054zm49.398.243l-7.234 7.477-7.396 7.64-.136.134 7.046 6.83 7.639 7.422.459.432a4.44 4.44 0 00.648-2.348V36.259c0-1.118-.388-2.132-1.026-2.861zM30.82 49.567l-6.748 6.56-7.666 7.422-.972.945c.512.33 1.095.54 1.728.54h44.674c.76 0 1.449-.292 2.024-.756l-.486-.486-7.666-7.423-7.045-6.802-6.344 6.532c-.343.228-.572.48-.908.635-.54.25-1.13.46-1.725.452-.596-.01-1.18-.243-1.715-.506-.269-.132-.412-.263-.727-.527l-6.424-6.586z"
      fill="#fff"
    />
    <circle cx={74} cy={14} r={12} fill="red" />
    <path
      d="M77.184 17.705V19h-5.6v-1.295h2.051v-5.901c0-.233.007-.474.021-.721L72.2 12.301a.64.64 0 01-.252.126.608.608 0 01-.42-.07.444.444 0 01-.126-.119l-.546-.749 3.088-2.625h1.42v8.841h1.82z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="prefix__paint0_linear"
        x1={39.544}
        y1={87.558}
        x2={39.62}
        y2={11.068}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#70EFFF" />
        <stop offset={1} stopColor="#5770FF" />
      </linearGradient>
    </defs>
  </svg>
);

export default MailIcon;
